define(function (require) {
    require("@modules/tools/ko.bootstrap-select");
    require("@modules/tools/ko.bootstrapSelect.typeahead");
    require("@modules/tools/ko.dpOpenClose");
    require("@plugins/knockout-multi-select/main");

    var ko = require("knockout");
    var $ = require("jquery");
    var PharmacySearchViewModel = require("@modules/tools/pharmacy-search/pharmacySearchViewModel");

    var gtmDataLayerPush = function (parameters, defaultParameters) {
        var dataLayer = window.dataLayer || [];

        var url = window.location.href.replace(/^.*\/\/[^\/]+/, "").split("?")[0];
        var jsonObject = {
            event: "gaPageview",
            eventCategory: "Pageview",
            eventAction: url,
            eventLabel: "Pharmacies Search"
        };

        if (parameters.year && parameters.year !== defaultParameters["year"]) {
            dataLayer.push({
                event: "gaEvent",
                eventCategory: "Lookup-pharmacies",
                eventAction: "Year",
                eventLabel: parameters.year
            });
        }

        if (parameters.zipOrAddress && parameters.zipOrAddress !== defaultParameters["zipOrAddress"]) {
            dataLayer.push({
                event: "gaEvent",
                eventCategory: "Lookup-pharmacies",
                eventAction: "Address",
                eventLabel: parameters.zipOrAddress
            });

            jsonObject.PharmacyAddress = true;
        }

        if (parameters.radius && parameters.radius !== defaultParameters["radius"]) {
            dataLayer.push({
                event: "gaEvent",
                eventCategory: "Lookup-pharmacies",
                eventAction: "MilesFromAddress",
                eventLabel: parameters.radius + " Miles"
            });
        }

        if (parameters.name && parameters.name !== defaultParameters["name"]) {
            dataLayer.push({
                event: "gaEvent",
                eventCategory: "Lookup-pharmacies",
                eventAction: "PharmacyName",
                eventLabel: parameters.name
            });

            jsonObject.PharmacyName = parameters.name;
        }

        if (parameters.pharmacyType.length) {
            dataLayer.push({
                event: "gaEvent",
                eventCategory: "Lookup-specialists",
                eventAction: "PharmacyType",
                eventLabel: parameters.pharmacyType
            });
            jsonObject.pharmacyType = true;
        }

        if (parameters.open24Hours && parameters.open24Hours !== defaultParameters["open24Hours"]) {
            dataLayer.push({
                event: "gaEvent",
                eventCategory: "Lookup-pharmacies",
                eventAction: "OpenTwentyFourHours",
                eventLabel: "Open 24 Hours Only"
            });
            jsonObject.pharmacyOpenTwentyFourHours = true;
        }

        if (parameters.preferredPharmacies && parameters.preferredPharmacies !== defaultParameters["preferredPharmacies"]) {
            dataLayer.push({
                event: "gaEvent",
                eventCategory: "Lookup-pharmacies",
                eventAction: "PreferredPharmaciesOnly",
                eventLabel: "Preferred Pharmacies Only"
            });
            jsonObject.pharmacyPreferredPharmaciesOnly = true;
        }
        if (parameters.has90DaySupply && parameters.has90DaySupply !== defaultParameters["has90DaySupply"]) {
            dataLayer.push({
                event: "gaEvent",
                eventCategory: "Lookup-pharmacies",
                eventAction: "Has90DaySupply",
                eventLabel: "Has 90 Day Supply Only"
            });
            jsonObject.pharmacyHas90DaySupply = true;
        }
        if (parameters.hasEPrescribing && parameters.hasEPrescribing !== defaultParameters["hasEPrescribing"]) {
            dataLayer.push({
                event: "gaEvent",
                eventCategory: "Lookup-pharmacies",
                eventAction: "HasEPrescribing",
                eventLabel: "Has E Prescribing Only"
            });
            jsonObject.pharmacyHasEPrescribing = true;
        }
        if (parameters.providesDeliveryService && parameters.providesDeliveryService !== defaultParameters["providesDeliveryService"]) {
            dataLayer.push({
                event: "gaEvent",
                eventCategory: "Lookup-pharmacies",
                eventAction: "ProvidesDeliveryService",
                eventLabel: "Provides Delivery Service Only"
            });
            jsonObject.pharmacyProvidesDeliveryService = true;
        }
        if (parameters.hasDriveThrough && parameters.hasDriveThrough !== defaultParameters["hasDriveThrough"]) {
            dataLayer.push({
                event: "gaEvent",
                eventCategory: "Lookup-pharmacies",
                eventAction: "HasDriveThrough",
                eventLabel: "Has Drive Through Only"
            });
            jsonObject.pharmacyHasDriveThrough = true;
        }

        dataLayer.push(jsonObject);
    };

    if ($("#pharmacy-search").length > 0) {
        ko.applyBindings(new PharmacySearchViewModel(gtmDataLayerPush));
        $(".hide-load").removeClass("hide-load");
        $(".tool-load").removeClass("tool-load");
    }
});
